import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import { Button } from '@/components/ui/button';
import { getRoutes } from '@/routes/routePaths';
import { useStripe } from '@stripe/react-stripe-js';
import { ArrowLeft, CircleCheckBig, CircleX, Info } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STATUS_CONTENT_MAP: any = {
  succeeded: {
    text: 'Thank you for your purchase',
    iconColor: '#30B130',
    icon: <CircleCheckBig className='w-40 h-40 text-[#30B130]' />,
  },
  processing: {
    text: 'Your payment is processing.',
    iconColor: '#6D6E78',
    icon: <Info className='w-40 h-40 text-[#6D6E78]' />,
  },
  ['requires_payment_method']: {
    text: 'Your payment was not successful, please try again.',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_capture']: {
    text: 'Something went wrong, please try again.1',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_action']: {
    text: 'Something went wrong, please try again.2',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_confirmation']: {
    text: 'Something went wrong, please try again.3',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
};

export default function CompletePage({ clientSecret }: { clientSecret: string | null }) {
  const navigate = useNavigate();
  const stripe = useStripe();
  const [status, setStatus] = useState('');
  const [intentId, setIntentId] = useState('');

  const handleGoBack = () => {
    navigate(getRoutes.Subscription);
  };
  useEffect(() => {
    if (!stripe) {
      return;
    }

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      if (!paymentIntent) {
        return;
      }
      setStatus(paymentIntent.status);
      setIntentId(paymentIntent?.id);
    });
  }, [stripe]);

  return (
    <div className='w-full  flex flex-col overflow-auto'>
      <HeaderWrapper className='fixed w-full top-0 z-50 flex-col md:flex-row gap-2'>
        <div className='flex w-full items-center gap-2'>
          <Button
            onClick={handleGoBack}
            id='session-details-back-btn'
            variant='ghost'
            size='icon'
            className='text-white'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
          <h1 className='text-lg font-semibold'>Back to Subscription</h1>
        </div>
      </HeaderWrapper>
      <div className='mx-auto w-[1060px] max-w-[98%] h-full mt-28 mb-16'></div>
      <div id='payment-status'>
        <div className='flex flex-col gap-5 items-center p-7'>
          {status ? (
            <>
              <div id='status-icon'>{STATUS_CONTENT_MAP[status].icon}</div>
              <h2 id='status-text' className='text-xl'>
                {STATUS_CONTENT_MAP[status].text}
              </h2>
            </>
          ) : (
            <div className='h-48'></div>
          )}
          <div className='flex items-center gap-2'>
            <p>Transaction ID:</p>
            <p>{intentId}</p>
          </div>
          <Button
            id='schedule-session-cancel-btn'
            variant='secondary'
            onClick={() => handleGoBack()}
            className='w-52'
          >
            Go to Subscription
          </Button>
        </div>
        {/* <Separator className='bg-[#FFFFFF21]' />
      <div className='flex items-center justify-end gap-4 w-full p-7'>
        <Button id='schedule-session-cancel-btn' variant='secondary' onClick={() => handleClose()}>
          Close
        </Button>
      </div> */}
      </div>
    </div>
  );
}
